module.exports = __webpack_public_path__ + "static/media/crane.8d0e5218.png";